module.exports = __webpack_public_path__ + "static/media/black.e02802dc.jpg";